import {BookOpen, MapPin, MessageCircle, Sparkles, X} from 'lucide-react';
import {VelaScene, type VelaRule} from '../engine/types';
import {CHAT_GUIDEBOOKS_CARD_ID} from './chat.rules';
import {CHAT_HOST_CARD_ID} from './registration.rules';

export const travelGuideRules: VelaRule[] = [
  {
    id: 'travelGuide/how-it-was-built',
    section: 'goodToKnow',
    scenes: [VelaScene.TravelGuide],
    priority: 30,
    evaluate: (_ctx, t) => ({
      id: 'travel-guide-how-it-was-built',
      icon: <Sparkles />,
      title: t('card.travel_guide_built_from.title'),
      description: t('card.travel_guide_built_from.body'),
    }),
  },
  {
    id: 'travelGuide/directions',
    section: 'goodToKnow',
    scenes: [VelaScene.TravelGuide],
    priority: 20,
    evaluate: (_ctx, t) => ({
      id: 'travel-guide-directions',
      icon: <MapPin />,
      title: t('card.travel_guide_directions.title'),
      description: t('card.travel_guide_directions.body'),
    }),
  },
  {
    id: 'travelGuide/dismiss',
    section: 'goodToKnow',
    scenes: [VelaScene.TravelGuide],
    priority: 10,
    evaluate: (_ctx, t) => ({
      id: 'travel-guide-dismiss',
      icon: <X />,
      title: t('card.travel_guide_dismiss.title'),
      description: t('card.travel_guide_dismiss.body'),
    }),
  },
  {
    id: 'travelGuide/guidebooks',
    section: 'quickActions',
    scenes: [VelaScene.TravelGuide],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.hasGuidebooks
        ? {
            id: CHAT_GUIDEBOOKS_CARD_ID,
            icon: <BookOpen />,
            title: t('card.chat_guidebooks.title'),
            description: t('card.chat_guidebooks.body'),
          }
        : null,
  },
  {
    id: 'travelGuide/chat-host',
    section: 'quickActions',
    scenes: [VelaScene.TravelGuide],
    priority: 10,
    evaluate: (ctx, t) =>
      ctx.isChatEnabled
        ? {
            id: CHAT_HOST_CARD_ID,
            icon: <MessageCircle />,
            title: t('card.travel_guide_ask_host.title'),
            description: t('card.travel_guide_ask_host.body'),
          }
        : null,
  },
];
